import { DateFormats, formatDate } from '@strata/helper-functions';
import { GridWithFilters, PrimaryData, SecondaryData } from '@strata/react-grid';

import { ListPageHeader } from 'components/ListPageHeader';
import { useGet } from 'services/Http';

const columns = [
    {
        header: 'Source',
        accessorKey: 'price_source',
        size: 100,
        cell: ({ getValue }) => <PrimaryData data={getValue()} />,
    },
    {
        header: 'Source Type',
        accessorKey: 'source_type',
        size: 75,
    },
    {
        header: 'Referent',
        accessorKey: 'referent_price_type',
        size: 75,
    },
    {
        header: 'Effective Date',
        accessorKey: 'price_date',
        size: 75,
        cell: ({ getValue }) => <SecondaryData data={formatDate(getValue())} />,
    },
    {
        header: 'Modified On',
        accessorKey: 'last_uploaded_at',
        size: 100,
        cell: ({ getValue }) => (
            <SecondaryData data={formatDate(getValue(), DateFormats.DATE_TIME)} />
        ),
    },
    {
        header: 'Modified By',
        accessorKey: 'modified_by',
        size: 100,
    },
];

const filterCategories = [
    {
        key: 'price_source',
        title: 'Source',
    },
    {
        key: 'source_type',
        title: 'Source Type',
    },
];

export const PriceLists = () => {
    const priceLists = useGet('/reference/prices/pricelist/uploads');
    const priceListData = priceLists?.map((list) => ({
        ...list,
        source_type: list.is_standard_source ? 'Standard' : 'Health Plan',
    }));

    return (
        <div className="sds_filter-list">
            <GridWithFilters
                headerContent={
                    <ListPageHeader
                        pageTitle="Price Lists"
                        buttons={[
                            {
                                label: 'Bulk Upload New Price List',
                                path: '/price-list/upload',
                            },
                        ]}
                    />
                }
                enableSearch
                filterCategories={filterCategories}
                sortProperties={[{ id: 'price_source', desc: false }]}
                isLoading={!priceListData}
                data={priceListData}
                columns={columns}
            />
        </div>
    );
};
